import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccessTokenService } from '../core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  constructor(private _acessTokenService: AccessTokenService,
    private _router: Router) { }

  ngOnInit(): void {
    this.checkIfSessionExists();
  }

  checkIfSessionExists() {
    if (this._acessTokenService.getTokenDetails(false)) {
      this._router.navigate(['landing/summary']);
    }
  }

}
